import { MyHomeIcon } from 'assets/icons/brikks/MyHomeIcon';
import { WashingMachine } from 'assets/icons/WashingMachine';
import React from 'react';

const mapIconToResourceType = (type) => {
  if (type.includes('laundry')) return <WashingMachine />;

  return <MyHomeIcon />;
};

export const mapDataForClient = (item) => ({
  id: item?.id,
  name: item?.name,
  type: item?.type,
  address: item?.location?.address?.formatted.split('\n').join(' - '),
  icon: mapIconToResourceType(item?.type),
});
